import React from 'react';
import JobApllyButton from './JobApllyButton';
class JobSingleHero extends React.Component {
  render() {
    function decodeHTMLEntities(text) {
      if(text){
        var entities = [
          ['amp', '&'],
          ['apos', '\''],
          ['#x27', '\''],
          ['#x2F', '/'],
          ['#39', '\''],
          ['#47', '/'],
          ['lt', '<'],
          ['gt', '>'],
          ['nbsp', ' '],
          ['quot', '"']
      ];

      for (var i = 0, max = entities.length; i < max; ++i)
          text = text.replace(new RegExp('&'+entities[i][0]+';', 'g'), entities[i][1]);
      }
      return text;
  }
    return (
      <header className="header header--sub2 header--jobpost">
        <div className="box">
          <span className="box-tag">{decodeHTMLEntities(this.props.job_data.location)}</span>
          <span className="box-title">{decodeHTMLEntities(this.props.job_data.title)}</span>
          <JobApllyButton key={this.props.job_data._id} job_data={this.props.job_data} />
        </div>
        <div className="header-shape"></div>
      </header>
    )
  }
}

export default JobSingleHero;
